import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { product } from 'src/app/models/interfaces';
import { AlertsService } from 'src/app/services/alerts.service';
import { CarritoService } from 'src/app/services/carrito.service';
import { PreloadImgService } from 'src/app/services/preload-img.service';

@Component({
  selector: 'app-producto3d',
  templateUrl: './producto3d.component.html',
  styleUrls: ['./producto3d.component.scss'],
})
export class Producto3dComponent implements OnInit {



  @Input() producto : any
  @Input() genero?: string = '';
  imgDefault = this.preloadImg.defaultImg
  constructor(public carrito: CarritoService,
    private fb: FormBuilder,
    private alersSv : AlertsService,
    public router : Router,
    private preloadImg : PreloadImgService, ) { }

    formCantidad = this.fb.group({
      talla: [null, Validators.required],
      cantidad: [1, Validators.required]
    })

  addProd =[]

  // Mapeo plural → singular (igual que en detail-product)
private readonly singulares: Record<string, string> = {
  'mujeres': 'mujer',
  'hombres': 'hombre',
  'ninos':   'nino',
  'ninas':   'nina',
};

get imagenDelGenero(): string {
  if (!this.producto?.image?.length) return this.imgDefault;

  const genero = this.genero;
  if (!genero) return this.producto.image[0]?.url || this.imgDefault;

  const singular = this.singulares[genero] ?? genero;

  const match = this.producto.image.find((img: any) =>
    img?.url && (
      !img.gender ||
      img.gender === genero ||
      img.gender === singular
    )
  );

  return match?.url || this.producto.image[0]?.url || this.imgDefault;
}

  ngOnInit() {
    this.formCantidad.valueChanges.subscribe(
      res =>{
        this.addProd = []
        this.addProd.push(res)
      }
    )
  }
  async addProduct(){
    console.log("add desde producto");

    if (this.carrito.auth.uid) {
      if (this.producto.colors) {
        this.router.navigate(['/detailproduct',this.producto.id])
        return
      }
      if (this.addProd.length < 1 && !this.producto.colors) {
        this.alersSv.presentAlert('por favor selecciona la talla del producto')
      } else {
        await this.carrito.addProduct(this.producto, this.addProd) ;
        this.alersSv.presentToast('bottom', 'Producto agregado al carrito')
        this.formCantidad.reset()
      }
    }
    else{
      this.alersSv.presentAlert('Para hacer un pedido debes iniciar sesion')
      this.router.navigate(['/singin'])
    }
  }


}
